import { combineReducers } from "redux";
import dimension from "./dimension";
import gameState from "./gameState";
import user from "./user";
import currentMail from "./currentMail";
import orgChart from "./orgChart";
import timerDetails from './timerDetails'
import surveySequences from "./surveySequences";
import selfActor from "./selfActor";
import introductionData from './introductionData'
import defaultStrings from './defaultStrings'

export default combineReducers({
	dimension,
	gameState,
	user,
	orgChart,
	currentMail,
	surveySequences,
	timerDetails,
	selfActor,
	introductionData,
	defaultStrings
});



// WEBPACK FOOTER //
// /src/reducers/uiState/index.js